import Axios from 'axios';
import Settings from '@/config/settings';

export default {
  namespaced: true,
  state: {
    userPreferences: []
  },
  getters: {
    accessToken: state => {
      return state.accessToken;
    },
    userPreferences: state => {
      return state.userPreferences;
    },
    preferenceSwiper: () => {
      return {
        question1: {
          initialSlide: 2,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: false,
          followFinger: false,
          longSwipes: false,
          slideToClickedSlide: true
        },
        question2: {
          initialSlide: 2,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: false,
          followFinger: false,
          longSwipes: false,
          slideToClickedSlide: true
        },
        question3: {
          initialSlide: 2,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: false,
          followFinger: false,
          longSwipes: false,
          slideToClickedSlide: true
        },
        question4: {
          initialSlide: 2,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: false,
          followFinger: false,
          longSwipes: false,
          slideToClickedSlide: true
        }
      };
    }
  },
  mutations: {
    SET_USER_PREFERENCES: (state, preferences) => {
      state.userPreferences = preferences;
    }
  },
  actions: {
    async saveUserPreferences ({ commit, state }, payload) {
      commit('SET_USER_PREFERENCES', payload);
    },
    async fetchUserPreferences ({ commit, state }, userId) {
      if (!state.userPreferences.length) {
        await Axios.get(
          `${Settings.nodeApi.uri}getPreference?userId=${userId}&userPreference=MYDTM_PREFERENCE`, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
          if (res.data && res.data.data && res.data.data.length) {
            const savedPreferences = {};
            res.data.data.forEach((d) => {
              savedPreferences[`${d.p}.${d.q}`] = {
                id: d.i,
                userPreference: d.p,
                userPreferenceQuestion: d.q,
                tagId: d.t,
                answer: d.a
              };
            });
            this.dispatch('adb2c/saveUserPreferences', savedPreferences);
          }
        });
      }
    }
  }
};
